import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const RFQContext = createContext(null);

const STORAGE_KEY = "novocreste_enquiry_list";

export function RFQProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [enquiry, setEnquiry] = useState([]);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) setEnquiry(JSON.parse(raw));
    } catch (e) {
      // ignore
    }
  }, []);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(enquiry));
    } catch (e) {
      // ignore
    }
  }, [enquiry]);

  const addToEnquiry = useCallback((item) => {
    setEnquiry((prev) => {
      if (prev.find((p) => p.slug === item.slug)) return prev;
      return [...prev, item];
    });
  }, []);

  const removeFromEnquiry = useCallback((slug) => {
    setEnquiry((prev) => prev.filter((p) => p.slug !== slug));
  }, []);

  const clearEnquiry = useCallback(() => setEnquiry([]), []);

  const openRFQ = useCallback(() => setOpen(true), []);
  const closeRFQ = useCallback(() => setOpen(false), []);

  const isInEnquiry = useCallback(
    (slug) => enquiry.some((p) => p.slug === slug),
    [enquiry]
  );

  const value = useMemo(
    () => ({
      open,
      setOpen,
      openRFQ,
      closeRFQ,
      enquiry,
      addToEnquiry,
      removeFromEnquiry,
      clearEnquiry,
      isInEnquiry,
    }),
    [open, openRFQ, closeRFQ, enquiry, addToEnquiry, removeFromEnquiry, clearEnquiry, isInEnquiry]
  );

  return <RFQContext.Provider value={value}>{children}</RFQContext.Provider>;
}

export function useRFQ() {
  const ctx = useContext(RFQContext);
  if (!ctx) throw new Error("useRFQ must be used within RFQProvider");
  return ctx;
}
